// extracted by mini-css-extract-plugin
export default {"ScoreCard":"ScoreCard_ScoreCard__cfvqA","largeContent":"ScoreCard_largeContent__RapjC","smallContent":"ScoreCard_smallContent__46iKr","title":"ScoreCard_title__jR8S6"};